
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  props: {
    dataSet: {}
  },
  computed: {
    chartData() {
      return {
        labels: this.dataSet.labels,
        datasets: [
          {
            label: "Tensi",
            yAxisID: "A",
            type: "bar",
            data: this.dataSet.tensi,
            barThickness: 5,
            backgroundColor: "black",
            order: 5
          },
          {
            label: "Nadi",
            yAxisID: "A",
            data: this.dataSet.nadi,
            pointRadius: 3,
            borderWidth: 2,
            spanGaps: true,
            tension: 0,
            fill: false,
            borderColor: "red",
            backgroundColor: "red",
            pointStyle: "star"
          },
          {
            label: "SpO2",
            yAxisID: "B",
            data: this.dataSet.spo2,
            pointRadius: 3,
            borderWidth: 2,
            spanGaps: true,
            tension: 0,
            fill: false,
            borderColor: "blue",
            backgroundColor: "blue"
          },
          {
            label: "MAP",
            yAxisID: "A",
            data: this.dataSet.mapVal,
            pointRadius: 3,
            borderWidth: 2,
            spanGaps: true,
            tension: 0,
            fill: false,
            borderColor: "green",
            backgroundColor: "green",
            borderDash: [5, 5]
          }
        ]
      };
    },
    options() {
      return {
        scales: {
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "Menit ke-"
              },
              ticks: {
                callback: function(value: any) {
                  return value;
                }
              }
            }
          ],
          yAxes: [
            {
              id: "A",
              scaleLabel: {
                display: true,
                labelString: "TD / Nadi / MAP (mmHg/bpm)"
              },
              display: true,
              position: "left",
              ticks: {
                min: 0,
                max: 240,
                stepSize: 20,
                beginAtZero: true
              }
            },
            {
              id: "B",
              scaleLabel: {
                display: true,
                labelString: "SpO2 (%)"
              },
              display: true,
              position: "right",
              ticks: {
                min: 80,
                max: 100,
                stepSize: 5,
                beginAtZero: false
              },
              gridLines: {
                drawOnChartArea: false
              }
            }
          ]
        },
        legend: {
          display: true
        },
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          mode: "index",
          intersect: false,
          callbacks: {
            label: function(tooltipItem: any, data: any) {
              const label = data.datasets[tooltipItem.datasetIndex].label || "";

              if (String(label).toLowerCase() === "tensi") {
                try {
                  const val: Array<number> = JSON.parse(
                    tooltipItem.value.replace(/NaN/g, "null")
                  );
                  tooltipItem.value = val.join(" / ");
                } catch {
                  // keep original
                }
              }

              return `${label} : ${tooltipItem.value}`;
            }
          }
        },
        annotation: {
          annotations: [
            {
              type: "line",
              mode: "horizontal",
              scaleID: "A",
              value: 65,
              borderColor: "rgba(255, 0, 0, 0.5)",
              borderWidth: 1,
              borderDash: [5, 5],
              label: {
                enabled: true,
                content: "MAP 65",
                position: "left"
              }
            }
          ]
        }
      };
    }
  },

  mounted() {
    this.renderChart(this.chartData, this.options);
  },

  watch: {
    dataSet() {
      this.renderChart(this.chartData, this.options);
    }
  }
};
